<div class="banner relative z-[-1] h-[180px] lg:h-[478px]">
  <rd-bnz-homepage-banner-image> </rd-bnz-homepage-banner-image>
</div>
<div class="banner-container lg:screen-max-size lg:mb-[120px] lg:mt-[-415px]">
  <div class="banner-text w-full bg-white lg:w-[540px]">
    <h1
      [ngClass]="{
        'banner-title typo-heading-2-desktop lg:typo-heading-1-desktop m-0 px-4 py-0 pt-5 text-[#002f6b] lg:pl-7 lg:pr-3': true,
        'py-5': isBnzBankwideUpdatesEnabled
      }"
      [innerHTML]="'homepage.banner_title' | translate"></h1>
    <p
      *ngIf="!isBnzBankwideUpdatesEnabled"
      class="banner-subtitle typo-emphasis-5-mobile lg:typo-emphasis-4-desktop m-0 px-4 pb-5 pt-5 text-[#002f6b] lg:px-7">
      {{ 'homepage.banner_subtitle' | translate }}
    </p>
  </div>
</div>

<div class="links padding-until-widescreen mx-4 lg:mx-auto lg:mt-[-60px]">
  <div class="links-container flex flex-col lg:flex-row lg:py-5">
    <ng-container *ngFor="let quickLink of quickLinks">
      <bnz-homepage-quick-link
        [ngClass]="[
          'mx-4 lg:mx-0',
          isDeprecateFlybuysSchemeEnabled ? 'lg:w-1/4' : 'lg:w-1/5'
        ]"
        [iconClassName]="isDeprecateFlybuysSchemeEnabled ? 'p-1 lg:p-2' : ''"
        [iconSymbol]="quickLink.iconSymbol"
        [path]="quickLink.path"
        [text]="quickLink.text">
      </bnz-homepage-quick-link>
    </ng-container>
  </div>
</div>

<div
  *ngIf="isLoggedIn$ | async"
  class="lg:screen-max-size lg:padding-until-widescreen mx-5 lg:mx-auto">
  <bnz-bankwide-homepage-banner> </bnz-bankwide-homepage-banner>
</div>

<bnz-featured-partner-v2></bnz-featured-partner-v2>

<div
  class="offers lg:screen-max-size lg:padding-until-widescreen mx-4 py-16 lg:mx-auto">
  <h2
    class="typo-heading-2-desktop lg:typo-heading-2-desktop m-0 text-[#002f6b]">
    Your latest offers
  </h2>
  <p class="typo-text-mobile m-0 mt-4 text-[#002f6b]"></p>

  <div
    class="recommended-offers recommended-offers-loading pt-4 lg:pt-8"
    *ngIf="showOffersLoading$ | async">
    <ng-container *ngFor="let offer of [1, 2, 3]">
      <div class="offer-list-item">
        <rd-offer-listing-item [loading]="true"> </rd-offer-listing-item>
      </div>
    </ng-container>
  </div>

  <div
    class="recommended-offers pt-4 lg:pb-8"
    *ngIf="
      (showOffersLoading$ | async) === false && (offers$ | async) as offers
    ">
    <ng-container *ngFor="let offer of offers">
      <bnz-offer-listing-item
        *ngIf="isBnzBankwideUpdatesEnabled; else defaultOfferItem"
        class="w-full"
        [url]="'/offers/details/' + offer.id"
        [brand]="offer.brand"
        [title]="offer.title"
        [categoryIcon]="''"
        [logo]="offer.logoUrl"
        [cover]="offer.coverImageUrl"
        [expiryTime]="offer.endTime"
        [source]="offer.source"
        [loading]="false">
      </bnz-offer-listing-item>

      <ng-template #defaultOfferItem>
        <rd-offer-listing-item
          class="w-full"
          [url]="'/offers/details/' + offer.id"
          [brand]="offer.brand"
          [title]="offer.title"
          [categoryIcon]="''"
          [logo]="offer.logoUrl"
          [cover]="offer.coverImageUrl"
          [loading]="false">
        </rd-offer-listing-item>
      </ng-template>
    </ng-container>

    <rd-shared-button
      class="see-all-offers"
      [buttonClass]="'see-all-offers'"
      [buttonText]="'See all offers'"
      [buttonTheme]="'secondary'"
      [redirectURL]="'/offers'">
    </rd-shared-button>
  </div>
</div>

<div class="bg-[#f2f8fb]">
  <div
    [ngClass]="[
      'mx-5 flex flex-1 flex-col gap-x-7 gap-y-12 py-[60px]',
      'lg:screen-max-size lg:padding-until-widescreen lg:mx-auto lg:flex-row lg:py-[70px]',
      '[&_img]:object-[0_80%]'
    ]">
    <div
      class="flex-1"
      *ngFor="
        let homepagePromotion of homepagePromotions$ | async;
        let i = index
      ">
      <img
        class="hidden h-[230px] w-full rounded-md object-cover lg:block"
        [src]="homepagePromotion.desktopImageUrl"
        alt="" />
      <img
        class="block h-[160px] w-full rounded-md object-cover lg:hidden"
        [src]="homepagePromotion.mobileImageUrl"
        alt="" />
      <h2
        class="typo-emphasis-1-desktop m-0 mt-3 text-[#002f6b]"
        [innerHTML]="homepagePromotion.title"></h2>
      <p
        class="typo-text-mobile m-0 mt-4 text-[#002f6b]"
        [innerHTML]="homepagePromotion.mainContent"></p>
      <bnz-shared-link
        class="mt-2 block font-bold"
        [text]="homepagePromotion.subContent"
        [path]="homepagePromotion.link"
        [showIcon]="false">
      </bnz-shared-link>
    </div>
  </div>
</div>

<div
  class="static-content lg:screen-max-size lg:padding-until-widescreen mx-4 flex flex-col py-8 lg:mx-auto lg:py-12">
  <div class="grid gap-y-12 lg:grid-cols-3 lg:grid-rows-1">
    <div class="m-auto flex flex-col items-center gap-y-6">
      <img
        class="h-20 w-20"
        src="/assets/images/view-your-activity.png"
        alt="View your activity" />
      <bnz-shared-link
        class="block font-bold"
        text="View your activity"
        path="/points_activity">
      </bnz-shared-link>
    </div>
    <div class="m-auto flex flex-col items-center gap-y-6">
      <img
        class="h-20 w-20"
        src="/assets/images/about-bnz-rewards.png"
        alt="About BNZ rewards" />
      <div class="bnz-shared-link">
        <a
          class="link focus-link block font-bold"
          href="http://bnz.co.nz/rewards">
          About BNZ Rewards</a
        >
      </div>
    </div>
    <div class="m-auto flex flex-col items-center gap-y-6">
      <img class="h-20 w-20" src="/assets/images/faqs.png" alt="FAQs" />
      <bnz-shared-link class="lock font-bold" text="FAQs" path="/faq">
      </bnz-shared-link>
    </div>
  </div>
</div>
